import React from "react";

const HeroSection = () => {
  return (
    <section className="relative w-full h-screen overflow-hidden bg-white">
      {/* Background with gradient overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "linear-gradient(to bottom right, rgba(255,255,255,0.95) 35%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0.2) 65%, rgba(0,0,0,0) 100%), url('image-000.jpg')",
        }}
      ></div>

      {/* Hero Content */}
      <div className="relative z-10 flex items-center h-full pt-24 pb-10">
        <div className="w-full px-6">
          <div className="max-w-7xl mx-auto">
            <div className="w-full md:w-[65%] lg:w-[55%] flex flex-col gap-5 text-gray-800">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-accent leading-tight">
                Buy Original Car Spare Parts for Performance & Reliability
              </h1>

              <p className="text-gray-800 leading-relaxed font-medium md:text-lg max-w-xl">
                At Kharbanda Motors, we deliver premium genuine and OEM-grade
                parts engineered for accuracy, durability, and long-term
                reliability. Our parts are trusted by professionals and
                automotive workshops across India and abroad.
              </p>

              <p className="text-gray-800 font-medium md:text-lg max-w-xl">
                Explore genuine spare parts for Maruti Suzuki, Hyundai, Tata
                Motors, and other top brands, designed to give your vehicle the
                perfect fit and unmatched performance. Buy OEM-grade parts for
                your automobile at Kharbanda Motors.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
